module.exports = __webpack_public_path__ + "img/ltc.6046cca1.svg";